import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import XLSX from "xlsx";
import moment from "moment";
import smsServiceNew from "../../../api/reservePlanNew.service";
import constants from "../../../config/constants";
export default {
  name: "view-historical-sheets",
  components: { pageheader },
  data() {
    return {
      input: {},
      search: "",
      isDataLoading: false,
      historicalSheetList: [],
      excelHeader: [],
      isHistorySheetRecordDelete: false,
      HistoryDeleteId: "",
      deleteConfirmDialog: false,
      titleOfproject: "",
      errorMSG: "",
      headers: [
        { text: "Name", value: "projectionName" },
        { text: "Location", value: "projectionLocation" },
        { text: "Start Date", value: "projectionStartDate" },
        { text: "End Date", value: "projectionEndDate" },
        { text: "Jobsite", value: "projectionJobSite" },
        { text: "Job#", value: "projectionJobNo" },
        { text: "PO#", value: "projectionPONo" },
        { text: "Comments", value: "projectionJobComments" },
        { text: "Status", value: "projectionStatus" },
        { text: "Creator", value: "projectionCreatorName" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCustomerId",
      "smsUserId",
      "smsBirchLinkingId",
      "smsUserPermissions",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("viewHistoricalSheets", this.roles);

    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = constants.ERROR_COMPANY_NOT_SELECTED;
    } else {
      this.errorMSG = "";
      this.resetStoreGettersData();
      this.getActivityList();
    }
  },
  methods: {
    resetStoreGettersData() {
      this.$store.dispatch("setStoreReserveSMSStepVal", 1);
      this.$store.dispatch("setPlanningSheetTab", 1);
      this.$store.dispatch("setStoreProjectionID", "");
      this.$store.dispatch("setStoreReserveType", "");
      this.$store.dispatch("setStoreProjectionItemEquipment", "");
      this.$store.dispatch("setStoreProjectionItemID", "");
      this.$store.dispatch("setprojectionRoute", "");
      this.$store.dispatch("setCopyOfProjectionName", "");
    },
    async getActivityList() {
      this.isDataLoading = true;
      let typeOfSheet;
      typeOfSheet = "Historical";

      try {
        let response = await smsServiceNew.getActivityList(typeOfSheet);
        if (response && response.isSuccess) {
          this.historicalSheetList = response.data;
          this.isDataLoading = false;
        } else {
          this.historicalSheetList = [];
          this.isDataLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isDataLoading = false;
      }
    },
    copyProject(item) {
      this.$store.dispatch("setPlanningSheetTab", 1);
      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setStoreReserveType", "Copy");
      this.$store.dispatch("setStoreProjectionItemEquipment", "");
      this.$store.dispatch("setStoreProjectionItemID", "");
      this.$router.push({ name: "Create Planning Sheet" });
      this.$store.dispatch("setprojectionRoute", "Historical Sheets");
      this.$store.dispatch("setCopyOfProjectionName", item.projectionName);
    },
    viewProjectItemDetails(item) {
      this.$store.dispatch("setPlanningSheetTab", 3);
      this.$store.dispatch("setPlanningSheetTabPrev", null);

      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setPlanningSheetObj", item);
      this.$store.dispatch("setStoreReserveType", "View");
      this.$router.push({ name: "Create Planning Sheet" });
      this.$store.dispatch("setprojectionRoute", "Historical Sheets");
    },
    openDeleteProjectItem(item) {
      this.deleteConfirmDialog = true;
      this.titleOfproject = item.projectionName;
      this.HistoryDeleteId = item.projectionID;
    },
    closeDeleteDialog() {
      this.deleteConfirmDialog = false;
    },
    async deleteProjectItem() {
      this.isHistorySheetRecordDelete = true;
      try {
        let response = await smsServiceNew.deleteCurrentSheetRecord(
          this.smsUserId,
          this.HistoryDeleteId
        );
        if (response && response.isSuccess) {
          this.isHistorySheetRecordDelete = false;
          this.$toast.success("Deleted planning sheet successfully");

          this.closeDeleteDialog();
          this.getActivityList();
        } else {
          this.isHistorySheetRecordDelete = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isHistorySheetRecordDelete = false;
        this.$toast.error("Unable to delete");
      }
    },
    async unlockProject(item) {
      try {
        let response = await smsServiceNew.unlockPlanningsheet(
          item.projectionID
        );
        if (response && response.isSuccess) {
          this.$toast.success("Unlocked the project successfully");
          this.getActivityList();
        } else {
          this.$toast.error("Unable to unlock the project");
        }
      } catch (err) {
        this.$toast.error("Unable to unlock the project");
        console.log(err);
      }
    },
    downloadExcel() {
      this.excelHeader.push(["Historical Sheet Data"]);
      this.excelHeader.push([]);
      this.excelHeader.push([
        "Name",
        "Location",
        "Start Date",
        "End Date",
        "Jobsite",
        "Job #",
        "PO #",
        "Comments",
        "Status",
        "Creator",
      ]);

      let tempExcel = this.historicalSheetList.map(function (item) {
        delete item.projectionID;
        delete item.BirchCustomerUserID;
        delete item.customerID,
          delete item.birchUserID,
          delete item.canDeletePlanningSheet;
        delete item.canLockPlanningSheet;
        delete item.projectionCreatorUserID;
        delete item.projectionJobSiteNo;
        return item;
      });
      for (var i = 0; i < tempExcel.length; i++) {
        if (tempExcel[i]["projectionStartDate"]) {
          tempExcel[i]["projectionStartDate"] = moment(
            tempExcel[i]["projectionStartDate"]
          ).format("MM/DD/YYYY");
        }
        if (tempExcel[i]["projectionEndDate"]) {
          tempExcel[i]["projectionEndDate"] = moment(
            tempExcel[i]["projectionEndDate"]
          ).format("MM/DD/YYYY");
        }
      }
      // Data starts on the row after the header rows pushed above.
      let datarow = "A" + (this.excelHeader.length + 1);
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header: [
          "projectionName",
          "projectionLocation",
          "projectionStartDate",
          "projectionEndDate",
          "projectionJobSite",
          "projectionJobNo",
          "projectionPONo",
          "projectionJobComments",
          "projectionStatus",
          "projectionCreatorName",
        ],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Historical Sheet Data");
      this.excelHeader = [];
      XLSX.writeFile(wb, "Historical Sheet Data.xlsx");
    },
  },
};
